module.exports = (__webpack_require__(/*! dll-reference dll_6f4f7e3c49ef3773c914 */ "dll-reference dll_6f4f7e3c49ef3773c914"))("./node_modules/react/index.js");